import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'facturaPrefijo'
})
export class FacturaPrefijoPipe implements PipeTransform {

  transform(value: number): string {
    if (value !== undefined && value !== null) {
      return value.toString().padStart(5, '0');
    } else {
      return "";
    }
  }

}
